import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Keep or replace with your global styles
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CssBaseline, ThemeProvider } from '@mui/material'; // Import ThemeProvider
import theme from './theme'; // Import the custom theme
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={theme}> {/* Wrap App with ThemeProvider */}
        <CssBaseline /> {/* Apply baseline styles (important to be inside ThemeProvider) */}
        <App /> {/* AuthProvider is now inside App.js */}
      </ThemeProvider>
    </LocalizationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
